import { useQuery } from '@tanstack/vue-query';
import { cleeService } from '../services/clee.service';

export const useAccountDomains = () => {
  const { currentProject } = useCurrentProject();
  const { account } = useCurrentAccount();

  const accountId = computed(() => account.value?.id);

  const isAccountDomainsQueryEnabled = computed(() => !!accountId.value);

  const { data: domains, isLoading } = useQuery({
    queryKey: ['account-domains', currentProject.value?.id],
    queryFn: () => {
      if (!accountId.value) return;
      return cleeService.getDomainsByAccountId(accountId.value);
    },
    retry: false,
    select: (response) => response?.data.data,
    enabled: isAccountDomainsQueryEnabled,
  });

  return {
    domains,
    isLoading,
  };
};
